const Configure = require("./ms-configure");
const AccessToken = require("./ms-access-token");
const RefreshToken = require("./ms-refresh-token");
const Service = require("./ms-service");

const MS = {
  Configure,
  AccessToken,
  RefreshToken,
  Service,
};

module.exports = MS;
